var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 469,
    height: 419,
    viewBox: "0 0 469 419",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M415.167 280.353C445.356 221.776 419.964 153.773 360.829 121.924L359.744 121.365L306.431 104.872L276.801 162.364L235.496 237.178C242.105 187.042 250.391 133.651 257.263 106.989C270.483 52.0221 238.088 66.9031 223.946 62.3603C209.804 57.8175 158.07 46.2568 119.954 82.9009C83.4821 119.02 200.21 310.976 194.783 308.179C189.915 304.297 143.343 226.752 81.7082 175.767C21.718 124.256 25.5036 218.19 34.4503 246.14C40.2393 264.225 103.748 295.583 150.45 316.907L240.598 357.876L241.684 358.435C301.377 389.2 371.56 364.964 402.308 305.302L415.167 280.353Z",
    fill: "#4C37FE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.80cb914f25ef1608d6dbbc7728ffa646.svg";
export { ForwardRef as ReactComponent };